// extracted by mini-css-extract-plugin
module.exports = {"selectablerow":"DynamicTable_selectablerow__1g4gB","header":"DynamicTable_header__2PIYJ","table":"DynamicTable_table__Lnmer"};